import { render, staticRenderFns } from "./TextInputElementPreview.vue?vue&type=template&id=3a6b743f&scoped=true"
import script from "./TextInputElementPreview.vue?vue&type=script&lang=js"
export * from "./TextInputElementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b743f",
  null
  
)

export default component.exports